/**
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║                         BRAND CONFIGURATION                              ║
 * ║           Change these values when forking for a new creator             ║
 * ╠═══════════════════════════════════════════════════════════════════════════╣
 * ║                                                                           ║
 * ║  This is the SINGLE SOURCE OF TRUTH for all brand-specific values        ║
 * ║  in the fan-facing frontend. When forking for a new creator/company,     ║
 * ║  change the values here. index.html must also be updated manually.       ║
 * ║                                                                           ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 */

// ============================================================================
// CREATOR IDENTITY
// ============================================================================

/** Creator's display name */
export const CREATOR_NAME = 'Braydin'

/** Brand name (used in titles, headers) */
export const BRAND_NAME = 'Braydin Wright'

/** Site domain (without protocol) */
export const SITE_DOMAIN = 'braydinwright.com'

/** Community/fan group name */
export const COMMUNITY_NAME = 'Braydin Wright'

/** Product/world name */
export const PRODUCT_NAME = 'Braydin Wright'

/** Creator's initials (used in signatures) */
export const CREATOR_INITIALS = 'bw'

// ============================================================================
// CONTACT & SOCIAL
// ============================================================================

/** Primary support email */
export const SUPPORT_EMAIL = 'braydin@fansupportdesk.com'

/** Twitter/X handle */
export const TWITTER_HANDLE = 'braydinwright'

/** Twitter/X URL */
export const TWITTER_URL = 'https://twitter.com/braydinwright'

// ============================================================================
// PAGE COPY
// ============================================================================

/** Login page header */
export const LOGIN_TITLE = 'Braydin Wright'

/** Login page subtitle */
export const LOGIN_SUBTITLE = 'PRIVATE COMMUNITY'

/** Apply page header */
export const APPLY_TITLE = 'Braydin Wright'

/** Apply page subtitle */
export const APPLY_SUBTITLE = 'Membership Application'

/** Community membership question */
export const COMMUNITY_QUESTION = `Are you an active ${COMMUNITY_NAME} member?`

/** Application confirmation message */
export const CONFIRMATION_MESSAGE = `You're now in line to join ${PRODUCT_NAME}. Please be patient while your application is reviewed. If you'd like it reviewed sooner, you can choose to expedite your application.`

/** Chat bot persona name */
export const CHAT_BOT_NAME = 'Braydin'

// ============================================================================
// WELCOME MESSAGES
// ============================================================================

/** Welcome back message for returning users */
export const WELCOME_BACK_MESSAGE = `Welcome to Braydin Wright — the last and final stop on the journey in my community. If you're reading this, you've been personally invited to this ecosystem. I've decided to create my own little world where you can find everything and anything on me. I plan on spending much more time here and eventually making it the only place you can find me. Thank you for following along the journey. Welcome in.`

/** Post-payment welcome message */
export const POST_PAYMENT_WELCOME_MESSAGE = `Welcome to Braydin Wright! I'm so happy you're here. This is your exclusive space to connect with me directly. I can't wait to get to know you better.`

/** Welcome message signature */
export const WELCOME_SIGNATURE = CREATOR_INITIALS

// ============================================================================
// BRAND COLORS (for chat widget and inline styles)
// ============================================================================

export const BRAND_COLORS = {
  primary: '#6B7850',         // olive / moss (primary)
  primaryDark: '#5C5B44',     // darker olive (hover)
  primaryDarker: '#4A4A38',   // darkest olive
  backgroundLight: '#ECE6DD', // sand
  backgroundAccent: '#F6F3EE', // cream
  inputBorder: '#BAB6A8',     // taupe
  themeColor: '#6B7850',      // olive
}
